import { Grid } from "@material-ui/core";
import { useEffect, useRef } from "react";
import { Button, FileField, FileInput, ImageField, ImageInput, required, SaveButton, SimpleForm, TextInput, Toolbar } from "react-admin";
import { useForm } from "react-final-form";
import { PopupboxManager } from "react-popupbox";

const cleanPopupForm = () => {
  //   popupForm.change("set_name", undefined);
  //   popupForm.change("voting_question", undefined);
  //   popupForm.change("canned_message_start_time", undefined);
  //   popupForm.change("canned_message_end_time", undefined);
  //   popupForm.change("canned_messages", undefined);
  //   popupForm.change("voting_enabled", undefined);
};

const CustomToolbar = ({ item, type, handleSave, ...props }) => {
  const popupForm = useForm();

  const onSave = async (values) => {
    let result = {};
    if (item) {
      result = {
        id: item.id,
        type: type,
        purchase_image_info: {
          name: values.name,
          animation_icon_tv_file: values.animation_icon_tv_file,
          animation_icon_tv: values.animation_icon_tv_file ? values.animation_icon_tv_file.src : values.animation_icon_tv,
          animation_icon_mobile_file: values.animation_icon_mobile_file,
          animation_icon_mobile: values.animation_icon_mobile_file ? values.animation_icon_mobile_file.src : values.animation_icon_mobile,
          animation_icon_tv_file_name: values.animation_icon_tv_file ? values.animation_icon_tv_file.title : values.animation_icon_tv_file_name,
          animation_icon_mobile_file_name: values.animation_icon_mobile_file ? values.animation_icon_mobile_file.title : values.animation_icon_mobile_file_name,
          locked_icon_file: values.locked_icon_file,
          locked_icon: values.locked_icon_file ? values.locked_icon_file.src : values.locked_icon,
          unlocked_icon_file: values.unlocked_icon_file,
          unlocked_icon: values.unlocked_icon_file ? values.unlocked_icon_file.src : values.unlocked_icon,
        },
        delete: false,
      };
    } else {
      //Create new
      result = {
        type: type,
        purchase_image_info: {
          name: values.name,
          animation_icon_tv_file: values.animation_icon_tv_file,
          animation_icon_tv: values.animation_icon_tv_file.src,
          animation_icon_mobile_file: values.animation_icon_mobile_file,
          animation_icon_mobile: values.animation_icon_mobile_file.src,
          animation_icon_tv_file_name: values.animation_icon_tv_file.title,
          animation_icon_mobile_file_name: values.animation_icon_mobile_file.title,
          locked_icon_file: values.locked_icon_file,
          locked_icon: values.locked_icon_file.src,
          unlocked_icon_file: values.unlocked_icon_file,
          unlocked_icon: values.unlocked_icon_file.src,
        },
        delete: false,
      };
    }

    handleSave(result);

    cleanPopupForm(popupForm);
    PopupboxManager.close();
  };

  return (
    <Toolbar {...props}>
      <Button
        onClick={() => {
          cleanPopupForm(popupForm);
          PopupboxManager.close();
        }}
        label="Close"
      ></Button>
      <SaveButton onSave={onSave} label="Save" />
    </Toolbar>
  );
};

const PopupContent = ({ item }) => {
  const endRef = useRef(null);
  const popupForm = useForm();

  useEffect(() => {
    popupForm.change("name", item?.purchase_image_info?.name);
    popupForm.change("locked_icon", item?.purchase_image_info?.locked_icon);
    popupForm.change("unlocked_icon", item?.purchase_image_info?.unlocked_icon);
    popupForm.change("animation_icon_tv", item?.purchase_image_info?.animation_icon_tv);
    popupForm.change("animation_icon_mobile", item?.purchase_image_info?.animation_icon_mobile);
    popupForm.change("animation_icon_tv_file_name", item?.purchase_image_info?.animation_icon_tv_file_name);
    popupForm.change("animation_icon_mobile_file_name", item?.purchase_image_info?.animation_icon_mobile_file_name);
  }, []);

  return (
    <>
      <Grid container spacing={1} fullWidth>
        <Grid item sm={12} md={12}>
          <TextInput source="name" label="Paid Icon Name" validate={required()} fullWidth />
        </Grid>
      </Grid>

      <Grid container spacing={1} fullWidth>
        <Grid item sm={12} md={6}>
          <ImageField source="locked_icon" title="Before purchase icon" />
          {item && item.purchase_image_info.locked_icon ? <img src={item.purchase_image_info.locked_icon} style={{ width: "100px" }} /> : ""}
          <ImageInput //
            label="Before purchase icon"
            source="locked_icon_file"
            accept="image/*"
            multiple={false}
            validate={item ? null : required()}
          >
            <ImageField source="src" />
          </ImageInput>
        </Grid>

        <Grid item sm={12} md={6}>
          {item && item.purchase_image_info.unlocked_icon ? <img src={item.purchase_image_info.unlocked_icon} style={{ width: "100px" }} /> : ""}
          <ImageInput //
            label="After purchase icon"
            source="unlocked_icon_file"
            accept="image/*"
            multiple={false}
            validate={item ? null : required()}
          >
            <ImageField source="src" />
          </ImageInput>
        </Grid>
      </Grid>

      <Grid container spacing={1} fullWidth>
        <Grid item sm={12} md={6}>
          {item && item.purchase_image_info.animation_icon_tv ? (
            <a href={item.purchase_image_info.animation_icon_tv} target="_blank" rel="noopener noreferrer">
              <span>{item.purchase_image_info.animation_icon_tv_file_name}</span>
            </a>
          ) : (
            ""
          )}
          <FileInput //
            label="Smart TV Animation (format: json file)"
            source="animation_icon_tv_file"
            accept=".json,application/json"
            multiple={false}
            validate={item ? null : required()}
            // validate={zipValidator(item?.animation_icon_tv)}
          >
            <FileField source="src" title="title" />
          </FileInput>
        </Grid>

        <Grid item sm={12} md={6}>
          {item && item.purchase_image_info.animation_icon_mobile ? (
            <a href={item.purchase_image_info.animation_icon_mobile} target="_blank" rel="noopener noreferrer">
              <span>{item.purchase_image_info.animation_icon_mobile_file_name}</span>
            </a>
          ) : (
            ""
          )}
          <FileInput //
            label="Mobile Animation (format: json file)"
            source="animation_icon_mobile_file"
            accept=".json,application/json"
            multiple={false}
            validate={item ? null : required()}
            // validate={zipValidator(item?.animation_icon_mobile)}
          >
            <FileField source="src" title="title" />
          </FileInput>
        </Grid>
      </Grid>
      <div ref={endRef} />
    </>
  );
};

export const AddPaidIconDialog = ({ form, item, index, type, handleSave, ...props }) => {
  return (
    <SimpleForm {...props} toolbar={<CustomToolbar item={item} index={index} form={form} type={type} handleSave={handleSave} />}>
      <PopupContent form={form} item={item} />
    </SimpleForm>
  );
};
